<template>
  <div id="app">
    <div class="content-wrap" ref="main">
        <router-view />
    </div>
  </div>
</template>
<script>
    /**
     * 应用根组件
     * 功能：仅渲染 router-view，全局样式定义（最小宽度 1600px、表格错位修复）
     */
    export default {
        name: 'App'
    }
</script>

<style>
  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    font-family:"微软雅黑";
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    min-width: 1600px;
    background: #EFF2F6;
  }
  /*解决表格错位，必须加在index.html或APP.vue中*/
 body .el-table th.gutter{
   display: table-cell!important;
 }
</style>
